import { StoreState } from '../index';

export const productsSelector = (state: StoreState) => state.assortment.productInfo.products;
export const productsListSelector = (state: StoreState) => state.assortment.productInfo.productsList;
export const totalCommitmentsSelector = (state: StoreState) => state.assortment.totalCommitments;